import { render, staticRenderFns } from "./SidebarRetention.vue?vue&type=template&id=603ce3a8&scoped=true"
import script from "./SidebarRetention.vue?vue&type=script&lang=js"
export * from "./SidebarRetention.vue?vue&type=script&lang=js"
import style0 from "./SidebarRetention.vue?vue&type=style&index=0&id=603ce3a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603ce3a8",
  null
  
)

export default component.exports